<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.employee.leaveRecord.leaveRecord') }}
      </h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'leave-record-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end"></div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'leave_type_name'
          }"
        >
          <template v-slot="{ record }">
            <td class="with-img">
              <img
                class="height-30 ts-rounded"
                :src="photoEmp(record)"
                @error="onError(record)"
              />
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.employee
                  ? record.employee.name_en + '|' + record.employee.name_kh
                  : ''
              }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.date_from }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.time_from_show }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.date_to }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.time_to_show }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.total_day_show }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.leave_reason }}</td>
            <td class="text-center ts-whitespace-no-wrap">
              <a
                href="#"
                v-tooltip="$t('tooltip.edit')"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('tooltip.delete')"
                class="text-danger"
                @click.prevent="showForm(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './delete-form.vue'

export default {
  name: 'leave-record',
  components: { FormComponent },
  data() {
    return {
      loading: false,
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png')
    }
  },
  computed: {
    ...mapState('leaveRecord', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.leaveRecord.search
      },
      set(newValue) {
        this.$store.commit('leaveRecord/SET_SEARCH', newValue)
        this.$store.commit('leaveRecord/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('administration.employee.leaveRecord.employeePhoto') },
        {
          name: this.$t('administration.employee.leaveRecord.employeeName')
        },
        {
          name: this.$t('administration.employee.leaveRecord.dateFrom'),
          style: 'text-align:center'
        },
        {
          name: this.$t('administration.employee.leaveRecord.timeFrom'),
          style: 'text-align:center'
        },
        {
          name: this.$t('administration.employee.leaveRecord.dateTo'),
          style: 'text-align:center'
        },
        {
          name: this.$t('administration.employee.leaveRecord.timeFrom'),
          style: 'text-align:center'
        },
        {
          name: this.$t('administration.employee.leaveRecord.totalLeave'),
          style: 'text-align:center'
        },
        {
          name: this.$t('administration.employee.leaveRecord.leaveReason')
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:1%'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('leaveRecord/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('leaveRecord/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'leave-record-edit',
        params: { id: record.lr_id }
      })
    },
    showForm(data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('leaveRecord/destroy', record.lr_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    photoEmp(record) {
      if (record.employee.photo) {
        return record.employee.photo
      }

      return record.employee.sex == 1 ? this.manPhoto : this.womenPhoto
    },

    onError(record) {
      event.target.src =
        record.employee.sex == 1 ? this.manPhoto : this.womenPhoto
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'leave-record-create') {
      this.$store.commit('leaveRecord/RESET_STATE')
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
